module.exports = __webpack_public_path__ + "static/java-6fa3c42c459df8ec94fbfd15f3a55ee4.png";